import {Controller} from "stimulus"
import {TimelineLite} from "gsap/TimelineLite"
import {TweenLite} from "gsap/TweenLite"

export default class extends Controller {

    static targets = [
    ]

    initialize() {
    }

    print(){
        window.print();
    }

}
